import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryProvider } from '@/app/providers/QueryProvider'
import { Router } from '@/app/router'
import { Toaster } from '@/shared/ui'
// Inter пакетом, а не с CDN: шрифт попадает в сборку, работает без сети
// и не зависит от чужого сервиса на странице входа. Переменная версия —
// один файл на все насыщенности вместо шести.
import '@fontsource-variable/inter'
import '@/app/styles/global.css'

const container = document.getElementById('root')
if (!container) throw new Error('в разметке нет #root')

createRoot(container).render(
  <StrictMode>
    <QueryProvider>
      <Router />
      {/* Один на всё приложение: уведомления шлют из любого места, а
          показывает их этот компонент в корне. */}
      <Toaster />
    </QueryProvider>
  </StrictMode>,
)
